import { render, staticRenderFns } from "./OneTimeSecretForm.vue?vue&type=template&id=4504f384"
import script from "./OneTimeSecretForm.vue?vue&type=script&lang=js"
export * from "./OneTimeSecretForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports